import NotificationSystem from 'react-notification-system';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';

import Footer from '../../Components/Footer/Footer';
import FuelTypeSelect from '../FuelTypes/FuelTypeSelect';

class FuelTankCreateForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fboId: props.location.state.fboId,
      id: null,
      name: '',
      capacity: 0,
      measured: 0,
      fuelTypeId: undefined,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleFuelTypeChange = this.handleFuelTypeChange.bind(this);
  }

  postForm() {


    const endPoint = `v1/fbos/${this.state.fboId}/fuel_trucks`;

    this.request = Api.get(endPoint, {
      method: 'POST',
      body: JSON.stringify({
        name: this.state.name,
      }),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then((response) => {
      if (response.fuelTrucks) {
        const tankEndPoint = `v1/fbos/${this.state.fboId}/fuel_trucks/${response.fuelTrucks.id}/fuel_tanks/`;

        Api.get(tankEndPoint, {
          method: 'POST',
          body: JSON.stringify({
            name: `${this.state.name} tank`,
            capacity: this.state.capacity,
            measured: this.state.measured,
            fuelTypeId: this.state.fuelTypeId,
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Api-Key': Auth.getBearerToken(),
          },
        }, false).then((tankResponse) => {
          if (tankResponse.fuelTank) {
            this.goBack();
          }
        });
      }
    }).catch((error) => {
      this.refs.notificationSystem.addNotification({
        message: "Unable to update Fuel Trucks." + error.message,
        level: 'error',
        position: 'bc'
      });
    })
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  handleSubmit() {
    this.postForm();
  }

  handleSubmitOnEnter(event) {
    if (event.keyCode === 13) {
      // this.handleSubmit();
    }
  }

  handleFuelTypeChange(value) {
    this.setState({ fuelTypeId: value });
  }

  render() {
    return (
      <div className='app'>
        <NotificationSystem ref="notificationSystem" />
        <main className="page-content">
          <div className="normal-page-header">
            <h1 className="left">Create Fuel Truck</h1>
            <div className="clear" />
          </div>
          <div className="edit-form page-content-items">
            <label>
              Name<br />
              <input
                id="name"
                type="string"
                value={this.state.name}
                onChange={e => this.setState({ name: e.target.value })}
                onKeyDown={this.handleSubmitOnEnter} />
            </label>
            <label>
            Capacity<br />
              <input
                id="capacity"
                type="number"
                value={this.state.capacity}
                onChange={e => this.setState({ capacity: e.target.value })}
                onKeyDown={this.handleSubmitOnEnter} />
            </label>
            <label htmlFor="measured">
            Quantity<br />
              <input
                id="measured"
                type="number"
                value={this.state.measured}
                onChange={e => this.setState({ measured: e.target.value })}
                onKeyDown={this.handleSubmitOnEnter}
              />
            </label>
            <label>
              Fuel Type<br />
              <FuelTypeSelect onSelectChange={this.handleFuelTypeChange} selectedValue={this.state.fuelTypeId} />
            </label>
            <button type="button" onClick={this.handleSubmit} className="btn btn-medium btn-primary">Create</button>
            <button type="button" onClick={this.goBack} className="btn btn-medium  btn-alternative-options">Cancel</button>
          </div>
          <Footer />
        </main>
      </div>
    );
  }
}

FuelTankCreateForm.propTypes = {
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      fboId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default FuelTankCreateForm;



// WEBPACK FOOTER //
// ./src/Containers/FuelTrucks/FuelTruckCreateForm.js